import {
  DemoAlarmIngestPayload,
  DemoAlarmIngestResponse,
} from '@hakimo-ui/hakimo/types';
import { toast } from '@hakimo-ui/hakimo/util';

export function notifyIngestResult(
  result: DemoAlarmIngestResponse,
  payload: DemoAlarmIngestPayload
) {
  const failedIds = new Set((result.errors ?? []).map((e) => e.alarmId));

  // Track alarm IDs already reported so that an alarm appearing in
  // multiple situations isn't double-counted (buildIngestBody dedupes
  // the wire payload the same way).
  const reported = new Set<string>();

  payload.situations.forEach((situation) => {
    const unreported = situation.alarmIds.filter((id) => !reported.has(id));
    unreported.forEach((id) => reported.add(id));
    if (unreported.length === 0) return;

    const failed = unreported.filter((id) => failedIds.has(id)).length;
    const succeeded = unreported.length - failed;
    const total = unreported.length;
    const message = `${succeeded} out of ${total} ${
      total > 1 ? 'alarms were' : 'alarm was'
    } ingested from '${situation.name}'`;
    toast(message, { type: failed === 0 ? 'success' : 'error' });
  });

  const manualIds = payload.manualAlarmIds ?? [];
  if (manualIds.length === 0) return;

  const failed = manualIds.filter((id) => failedIds.has(id));
  const succeededCount = manualIds.length - failed.length;

  if (succeededCount > 0) {
    toast(
      `${succeededCount} production alarm${
        succeededCount === 1 ? '' : 's'
      } ingested`,
      { type: 'success' }
    );
  }

  if (failed.length > 0) {
    toast(`Failed to ingest production alarms: ${failed.join(', ')}`, {
      type: 'error',
    });
  }
}
